module.exports = __webpack_public_path__ + "static/media/filter.0cf9286a.svg";